import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { Spinner } from '@/components/Spinner'

/** There is no login form of our own — Keycloak owns the credentials. */
export function LoginPage() {
  const { t } = useTranslation()
  const { status, login } = useAuth()

  useEffect(() => {
    if (status === 'anonymous') {
      void login()
    }
  }, [status, login])

  if (status === 'authenticated') {
    return <Navigate to="/" replace />
  }
  return <Spinner label={t('auth.redirecting')} />
}
